import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Logo } from "./Logo";

const links = [
  { href: "#problema", label: "Il problema" },
  { href: "#soluzione", label: "La soluzione" },
  { href: "#formula", label: "La formula" },
  { href: "#docente", label: "Il docente" },
  { href: "#location", label: "La location" },
  { href: "#chi-siamo", label: "Chi siamo" },
];

export const Nav = ({ onCta }) => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const linkColor = scrolled
    ? "text-[#4A5268] hover:text-[#16256B]"
    : "text-white/85 hover:text-white";

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, delay: 0.1, ease: [0.16, 1, 0.3, 1] }}
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${
        scrolled
          ? "border-b border-[#E4E8F2] bg-white/85 backdrop-blur-xl"
          : "bg-transparent"
      }`}
      data-testid="site-nav"
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-5 py-4 sm:px-8">
        <a href="#top" data-testid="nav-logo-link">
          <Logo variant={scrolled ? "dark" : "light"} />
        </a>

        <nav className="hidden items-center gap-8 lg:flex">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className={`font-body text-sm transition-colors ${linkColor}`}
              data-testid={`nav-link-${l.href.replace("#", "")}`}
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <button
            onClick={onCta}
            className="rounded-full bg-[#C9A227] px-5 py-2.5 font-display text-sm font-bold text-[#16256B] transition-transform duration-200 hover:scale-[1.04] active:scale-95"
            data-testid="nav-cta-button"
          >
            Prenota
          </button>
          <button
            className={`lg:hidden ${scrolled ? "text-[#16256B]" : "text-white"}`}
            onClick={() => setOpen((v) => !v)}
            aria-label="Menu"
            data-testid="nav-mobile-toggle"
          >
            <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              {open ? <path d="M18 6 6 18M6 6l12 12" /> : <path d="M3 12h18M3 6h18M3 18h18" />}
            </svg>
          </button>
        </div>
      </div>

      <AnimatePresence>
        {open && (
          <motion.nav
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.3 }}
            className="overflow-hidden border-t border-[#E4E8F2] bg-white/95 backdrop-blur-xl lg:hidden"
          >
            <div className="flex flex-col gap-1 px-5 py-4">
              {links.map((l) => (
                <a
                  key={l.href}
                  href={l.href}
                  onClick={() => setOpen(false)}
                  className="rounded-lg px-3 py-3 font-body text-base text-[#4A5268] transition-colors hover:bg-[#F4F6FB] hover:text-[#16256B]"
                  data-testid={`nav-mobile-link-${l.href.replace("#", "")}`}
                >
                  {l.label}
                </a>
              ))}
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </motion.header>
  );
};
